<template>
  <div class="revenue-filter card p-3 mb-4">
    <div class="row g-3 align-items-end">
      <div class="col-md-3">
        <label class="form-label small font-weight-bold">Từ ngày</label>
        <input 
          type="date" 
          class="form-control" 
          v-model="localFilter.startDate"
          @change="update"
        >
      </div>
      <div class="col-md-3">
        <label class="form-label small font-weight-bold">Đến ngày</label>
        <input 
          type="date" 
          class="form-control" 
          v-model="localFilter.endDate"
          @change="update"
        >
      </div>
      <div class="col-md-2">
        <label class="form-label small font-weight-bold">Nhân viên</label>
        <select class="form-control" v-model="localFilter.userId" @change="update">
          <option :value="null">Tất cả nhân viên</option>
          <option v-for="user in users" :key="user.id" :value="user.id">
            {{ user.name }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="form-label small font-weight-bold">Danh mục</label>
        <select class="form-control" v-model="localFilter.categoryId" @change="update">
          <option :value="null">Tất cả danh mục</option>
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">
            {{ cat.name }}
          </option>
        </select>
      </div>
      <div class="col-md-2 text-right">
        <button class="btn btn-outline-secondary btn-block" @click="reset">
          <i class="fas fa-sync"></i> Đặt lại
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RevenueFilter',
  props: {
    filter: Object,
    users: Array,
    categories: Array
  },
  data() {
    return {
      localFilter: { ...this.filter }
    };
  },
  watch: {
    filter: {
      handler(val) {
        this.localFilter = { ...val };
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', this.localFilter);
    },
    reset() {
      this.localFilter = {
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'),
        endDate: new Date().toLocaleDateString('en-CA'),
        userId: null,
        categoryId: null
      };
      this.update();
    }
  }
};
</script>
